import {formatPhoneDisplay} from '../../../../library/formatPhone';
import * as css from './TransactionInfoBlock.css';

interface TransactionInfoBlockProps {
    heading: string;
    name: string;
    phone?: string;
    email?: string;
    'data-cy'?: string;
}

function TransactionInfoBlock({heading, name, phone, email, 'data-cy': dataCy}: TransactionInfoBlockProps) {
    const contact = [phone && formatPhoneDisplay(phone), email].filter(Boolean).join(' · ');
    return (
        <css.block data-cy={dataCy}>
            <css.blockHeading>{heading}</css.blockHeading>
            <css.blockLine>{name}</css.blockLine>
            {contact && <css.blockContact dir="ltr">{contact}</css.blockContact>}
        </css.block>
    );
}

export default TransactionInfoBlock;
